import { CreditVoucher } from "./credit-voucher.entity";
import z from "zod";
import { currencyCode } from "src/utils/validation.util";
const voucherTypeSchema = z.enum(["TOP_UP", "PROMO", "PRIVATE_MODE", "PREMIUM", "MONTHLY_PREMIUM", "YEARLY_PREMIUM"]) satisfies z.ZodType<CreditVoucher["type"]>;

export const createCreditVouchersSchema = z.object({
  type: voucherTypeSchema,
  amount: z.coerce.number().min(0),
  currency: currencyCode,
  expiryDate: z.string().optional(),
  organizationId: z.string().optional(),
  projectId: z.string().optional(),
  count: z.coerce.number().positive(),
  subscriptionEndDate: z.string().optional(),
  useProjectEndDate: z.boolean().optional(),
  linkToProjectTermination: z.boolean().optional(),
}).superRefine((data, ctx) => {
  // If organization is selected, project must also be selected
  if (data.organizationId && !data.projectId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Project is required when organization is selected",
      path: ["projectId"],
    });
  }
  
  // If type is PREMIUM, subscriptionEndDate is required (unless useProjectEndDate checkbox is checked)
  // MONTHLY_PREMIUM and YEARLY_PREMIUM don't require subscriptionEndDate
  if (data.type === "PREMIUM" && !data.useProjectEndDate && !data.subscriptionEndDate) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Subscription end date is required for PREMIUM vouchers",
      path: ["subscriptionEndDate"],
    });
  }
});

export type CreateCreditVouchers = z.infer<typeof createCreditVouchersSchema>;

export const filterCreditVouchersSchema = z.object({
  id: z.string().optional(),
  code: z.string().optional(),
  redeemedBy: z.string().optional(),
  organizationId: z.string().optional(),
  type: voucherTypeSchema.optional(),
  currency: currencyCode.optional(),
  status: z.enum(["AVAILABLE", "REDEEMED"]).optional(),
});

export type FilterCreditVouchers = z.infer<typeof filterCreditVouchersSchema>;

export const redeemVoucherSchema = z.object({
  voucherCode: z.string().min(1, "Voucher code is required"),
  userId: z.string().min(1, "User ID is required"),
});

export type RedeemVoucherRequest = z.infer<typeof redeemVoucherSchema>;

export type RedeemVoucherResponse = {
  amount: number;
  currency: "KARMA" | "EUR";
};
